import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../customHooks/useAuth';
import "./CheckInInviteDecision.css";
import Header from '../components/Header';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../common/baseUrl';
import axiosInstance from '../../axiosInstance/axiosInstance';

export default function CheckInInviteDecision() {

  const location = useLocation();
  const navigate = useNavigate();
  const requestId = location.state?.requestId || "";
  const userId = location.state?.userId || "";
  const name = location.state?.name || "";
  const contact = location.state?.contact || "";
  const hotelName = location.state?.hotelName || "";
  const guests = location.state?.guests || "";
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const webCheckInId = location.state?.webCheckInId || "";
  const guestDetails = location.state?.guestDetails || "";
  // console.log("Guest Details : ",guestDetails);

  // User Authentication
  useAuth();

  // Check Id's
  useEffect(()=>{
    if(requestId==="" || userId===""){
      navigate("/bookings");
    } 
  },[requestId,userId,navigate]);

  // Date Format
  function formatDate(inputDate) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(inputDate);
    return date.toLocaleDateString('en-GB', options);
  }

  const userData = localStorage.getItem('user_id');
 


  // Accept Request
  const acceptCheckIn = async()=>{
    try{

      const passData = {
        approval : "GUEST_APPROVED"
      } 
      const response = await axiosInstance.put(`/api/v1/users/${userData}/web-checkin/${webCheckInId}`,passData);
      // console.log(response.data);
      navigate("/bookings",{state : {activeRequests : "requests"}});
      toast.success("Web CheckIn Invitation Accepted Successfully");
 

    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
  }


  // Reject Request
  const rejectCheckIn = async()=>{
    try{

      const passData = {
        approval : "GUEST_DENIED"
      } 
      const response = await axiosInstance.put(`/api/v1/users/${userData}/web-checkin/${webCheckInId}`,passData);
      // console.log(response.data);
      
      navigate("/bookings",{state : {activeRequests : "requests"}});
      toast.success("Web CheckIn Invitation Rejected Successfully")
     

    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
  }

 
  return (
    <div className='checkInInvite'>
      <Header title="Web CheckIn Invitation" />
      <div className='checkInInvite-data'>
        
        {/* Request Created */}
        {name && 
          <div className='checkInInvite-item'>
            <h4>
              Request Created By
            </h4>
            <div className='checkInInvite-field'>
              {name}
            </div>
          </div>
        }

        {/* Contact Number */}
        {contact && 
          <div className='checkInInvite-item'>
            <h4>
              Contact Number
            </h4>
            <div className='checkInInvite-field'>
              +{contact}
            </div>
          </div>
        }
        
        {/* Guests */}
        {guests && 
          <div className='checkInInvite-item'>
            <h4>
              Number of Guests
            </h4>
            <div className='checkInInvite-field'>
              {guests}
            </div>
          </div>
        }

        {/* Hotel Name */}
        {hotelName && 
          <div className='checkInInvite-item'>
            <h4>
              Hotel Name
            </h4>
            <div className='checkInInvite-field'>
              {hotelName}
            </div>
          </div>
        }

        {/* Check In Date */}
        {checkInDate && 
          <div className='checkInInvite-item'>
            <h4>
              Check In Date
            </h4>
            <div className='checkInInvite-field'>
              {formatDate(checkInDate) || "Check In Date"}
            </div>
          </div>
        }

        {/* Check Out Date */}
        {checkOutDate && 
          <div className='checkInInvite-item'>
            <h4>
              Check Out Date
            </h4>
            <div className='checkInInvite-field'>
              {formatDate(checkOutDate) || "Check Out Date"}
            </div>
          </div>
        }

        {/* Buttons */}
        {
          guestDetails.guest_approved ==="GUEST_UNSPECIFIED" &&
          <div className='checkInInvite-btn'>
            <button className='accept' onClick={acceptCheckIn}>Accept CheckIn</button>
            <button className='reject' onClick={rejectCheckIn} >Reject CheckIn</button>
          </div>
        }

      </div>
    </div>
  )
}
